import _ from 'lodash';
import App from '@/views/constants/app';

import Helpers from '@/shared/helpers/functions';

import ReportsOfSickness from '@/views/constants/reports-of-sickness';
import UwvDecisions from '@/views/constants/uwv-decisions';
import NewUwvDecisions from '@/views/constants/uwv-decision-new';

import ReportsOfSicknessResource from '@/resources/constants/reports-of-sickness';
import NewReportOfSickness from '@/views/constants/report-of-sickness-new';
import EditReportOfSickness from '@/views/constants/report-of-sickness-edit';
import ReportsOfSicknessImportNew from '@/views/constants/reports-of-sickness-import-new';
import NewPeriod from '@/views/constants/period-new';
import EditPeriod from '@/views/constants/period-edit';
import NewRecovery from '@/views/constants/recovery-new';
import EditRecovery from '@/views/constants/recovery-edit';

import { SubNavigationTab } from '@/shared/helpers/classes';
import TabHelper from '@/shared/helpers/tabs';

import Employers from '@/resources/constants/employers';

const state = {
  reportsOfSicknessTabs: [
    new SubNavigationTab({
      component: 'ReportsOfSicknessIndex',
      text: 'Verzuim overzicht',
      props: null,
      navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
      isCloseable: false,
      closeAction: null,
      isSingleTon: true,
      isActive: true
    })
  ]
};

const getters = {
  reportsOfSicknessTabs: state => state.reportsOfSicknessTabs
};

const actions = {
  [Employers.Actions.SELECT] ({ commit }) {
    commit(ReportsOfSickness.Mutations.CLEAR);
  },

  [ReportsOfSickness.Actions.Tabs.ADD] ({ commit }, tab) {

  },

  [ReportsOfSickness.Actions.Tabs.CLOSE] ({ commit }, tab) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE, tab);
  },

  [ReportsOfSickness.Actions.Tabs.OPEN] ({ commit }, tab) {
    commit(ReportsOfSickness.Mutations.Tabs.OPEN, tab);
  },

  [ReportsOfSickness.Actions.Tabs.OPEN_NEW] ({ commit }) {
    let tab = _.find(state.reportsOfSicknessTabs, t => {
      if (t.component === 'NewReportOfSickness') {
        return t;
      }
    });
    // let tab = null;
    if (_.isNil(tab)) {
      tab = new SubNavigationTab({
        component: 'NewReportOfSickness',
        text: 'Nieuw verzuim',
        props: null,
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: ReportsOfSickness.Actions.Tabs.CLOSE,
        isSingleton: true,
        isActive: false
      });
    }

    commit(ReportsOfSickness.Mutations.Tabs.ADD, tab);
    commit(ReportsOfSickness.Mutations.Tabs.OPEN, tab);
  },

  [ReportsOfSickness.Actions.Tabs.OPEN_IMPORT] ({ commit }) {
    let tab = _.find(state.reportsOfSicknessTabs, t => {
      if (t.component === 'ReportsOfSicknessImport') {
        return t;
      }
    });
    // let tab = null;
    if (_.isNil(tab)) {
      tab = new SubNavigationTab({
        component: 'ReportsOfSicknessImport',
        text: 'Import Verzuimen Overzicht',
        props: null,
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: ReportsOfSickness.Actions.Tabs.CLOSE,
        isSingleton: true,
        isActive: false
      });
    }

    commit(ReportsOfSickness.Mutations.Tabs.ADD, tab);
    commit(ReportsOfSickness.Mutations.Tabs.OPEN, tab);
  },

  [ReportsOfSickness.Actions.Tabs.OPEN_IMPORT_NEW] ({ commit }) {
    let tab = _.find(state.reportsOfSicknessTabs, t => {
      if (t.component === 'ReportsOfSicknessImportNew') {
        return t;
      }
    });
    // let tab = null;
    if (_.isNil(tab)) {
      tab = new SubNavigationTab({
        component: 'ReportsOfSicknessImportNew',
        text: 'Verzuimen Importeren',
        props: null,
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: ReportsOfSickness.Actions.Tabs.CLOSE,
        isSingleton: true,
        isActive: false
      });
    }

    commit(ReportsOfSickness.Mutations.Tabs.ADD, tab);
    commit(ReportsOfSickness.Mutations.Tabs.OPEN, tab);
  },

  [UwvDecisions.Actions.Tabs.New.OPEN] ({ commit }, data) {
    let tab = _.find(state.reportsOfSicknessTabs, t => {
      if (t.component === 'NewUwvDecision') {
        return t;
      }
    });

    if (_.isNil(tab)) {
      tab = new SubNavigationTab({
        component: 'NewUwvDecision',
        text: 'UWV beslissing doorgeven',
        props: { _reportOfSickness: data.reportOfSickness, _employee: data.employee },
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: ReportsOfSickness.Actions.Tabs.CLOSE,
        isSingleton: true,
        isActive: false
      });
    }

    commit(ReportsOfSickness.Mutations.Tabs.ADD, tab);
    commit(ReportsOfSickness.Mutations.Tabs.OPEN, tab);
  },

  [ReportsOfSickness.Actions.Tabs.OPEN_EDIT] ({ commit }, reportOfSickness) {
    let reportOfSicknessTab = _.find(state.reportsOfSicknessTabs, tab => {
      if (tab.component === 'EditReportOfSickness') {
        return tab;
      }
    });

    if (reportOfSicknessTab == null) {
      reportOfSicknessTab = new SubNavigationTab({
        component: 'EditReportOfSickness',
        text: 'Wijziging ziekmelding',
        props: { reportOfSickness: reportOfSickness },
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: ReportsOfSickness.Actions.Tabs.CLOSE,
        isSingleton: false,
        isActive: false
      });
    }

    commit(ReportsOfSickness.Mutations.Tabs.ADD, reportOfSicknessTab);
    commit(ReportsOfSickness.Mutations.Tabs.OPEN, reportOfSicknessTab);
  },

  [ReportsOfSickness.Actions.Tabs.OPEN_PERIOD] ({ commit }, reportOfSickness) {
    let reportOfSicknessTab = _.find(state.reportsOfSicknessTabs, tab => {
      if (tab.component === 'NewPeriod') {
        return tab;
      }
    });

    if (reportOfSicknessTab == null) {
      reportOfSicknessTab = new SubNavigationTab({
        component: 'NewPeriod',
        text: 'Wijziging doorgeven',
        props: { reportOfSickness: reportOfSickness },
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: ReportsOfSickness.Actions.Tabs.CLOSE,
        isSingleton: true,
        isActive: false
      });
    }

    commit(ReportsOfSickness.Mutations.Tabs.ADD, reportOfSicknessTab);
    commit(ReportsOfSickness.Mutations.Tabs.OPEN, reportOfSicknessTab);
  },

  [ReportsOfSickness.Actions.Tabs.OPEN_PERIOD_EDIT] ({ commit }, data) {
    let editPeriodTab = _.find(state.reportsOfSicknessTabs, tab => {
      if (tab.component === 'EditPeriod') {
        return tab;
      }
    });

    if (editPeriodTab == null) {
      editPeriodTab = new SubNavigationTab({
        component: 'EditPeriod',
        text: 'Wijziging bewerken',
        props: { _reportOfSickness: data.reportOfSickness, _period: data.period },
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: ReportsOfSickness.Actions.Tabs.CLOSE,
        isSingleton: true,
        isActive: false
      });
    }
    commit(ReportsOfSickness.Mutations.Tabs.ADD, editPeriodTab);
    commit(ReportsOfSickness.Mutations.Tabs.OPEN, editPeriodTab);
  },

  [ReportsOfSickness.Actions.Tabs.OPEN_RECOVERY] ({ commit }, reportOfSickness) {
    let reportOfSicknessTab = _.find(state.reportsOfSicknessTabs, tab => {
      if (tab.component === 'NewRecovery') {
        return tab;
      }
    });

    if (reportOfSicknessTab == null) {
      reportOfSicknessTab = new SubNavigationTab({
        component: 'NewRecovery',
        text: 'Herstel melden',
        props: { reportOfSickness: reportOfSickness },
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: ReportsOfSickness.Actions.Tabs.CLOSE,
        isSingleton: true,
        isActive: false
      });
    }
    commit(ReportsOfSickness.Mutations.Tabs.ADD, reportOfSicknessTab);
    commit(ReportsOfSickness.Mutations.Tabs.OPEN, reportOfSicknessTab);
  },

  [ReportsOfSickness.Actions.Tabs.OPEN_RECOVERY_EDIT] ({ commit }, data) {
    let reportOfSicknessTab = _.find(state.reportsOfSicknessTabs, tab => {
      if (tab.component === 'EditRecovery') {
        return tab;
      }
    });

    if (reportOfSicknessTab == null) {
      reportOfSicknessTab = new SubNavigationTab({
        component: 'EditRecovery',
        text: 'Herstelmelding wijzigen',
        props: { _reportOfSickness: data.reportOfSickness },
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: ReportsOfSickness.Actions.Tabs.CLOSE,
        isSingleton: true,
        isActive: false
      });
    }
    commit(ReportsOfSickness.Mutations.Tabs.ADD, reportOfSicknessTab);
    commit(ReportsOfSickness.Mutations.Tabs.OPEN, reportOfSicknessTab);
  },

  [ReportsOfSickness.Actions.Tabs.OPEN_DETAILS] ({ commit }, data) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    let reportOfSicknessTab = _.find(state.reportsOfSicknessTabs, tab => {
      if (tab.props != null && tab.props._reportOfSickness != null) {
        if (tab.props._reportOfSickness.id === data.reportOfSickness.id && tab.component === 'ReportOfSicknessDetails') {
          return tab;
        }
      }
    });

    if (reportOfSicknessTab == null) {
      reportOfSicknessTab = new SubNavigationTab({
        component: 'ReportOfSicknessDetails',
        text: `${data.employee.getFullName()} op ${Helpers.Dates.formatDate(data.reportOfSickness.firstOfAbsence)}`,
        props: { _reportOfSickness: data.reportOfSickness, _employee: data.employee },
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: ReportsOfSickness.Actions.Tabs.CLOSE,
        isSingleton: false,
        isActive: false
      });
    }

    commit(ReportsOfSickness.Mutations.Tabs.ADD, reportOfSicknessTab);
    commit(ReportsOfSickness.Mutations.Tabs.OPEN, reportOfSicknessTab);
  },

  [NewUwvDecisions.Actions.Cancel.DO] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'NewUwvDecision'));
  },

  [NewReportOfSickness.Actions.Cancel.DO] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'NewReportOfSickness'));
  },

  [EditReportOfSickness.Actions.Cancel.DO] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'EditReportOfSickness'));
  },

  [NewPeriod.Actions.Cancel.DO] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'NewPeriod'));
  },

  [EditPeriod.Actions.Cancel.DO] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'EditPeriod'));
  },

  [NewRecovery.Actions.Cancel.DO] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'NewRecovery'));
  },

  [EditRecovery.Actions.Cancel.DO] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'EditRecovery'));
  },

  [ReportsOfSicknessImportNew.Actions.CANCEL] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'ReportsOfSicknessImportNew'));
  },

  [ReportsOfSicknessResource.Actions.Period.Create.SUCCESS] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'NewPeriod'));
  },

  [ReportsOfSicknessResource.Actions.Period.Update.SUCCESS] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'EditPeriod'));
  },

  [ReportsOfSicknessResource.Actions.Recovery.Create.SUCCESS] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'NewRecovery'));
  },

  [ReportsOfSicknessResource.Actions.Recovery.Update.SUCCESS] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'EditRecovery'));
  },

  [ReportsOfSicknessResource.Actions.Create.SUCCESS] ({ commit, getters, dispatch, rootGetters }, data) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'NewReportOfSickness'));

    let employee = rootGetters.employees.find(e => e.id === data.employeeId);
    let reportOfSickness = rootGetters.reportsOfSicknessFlat.find(r => r.id === data.id);

    dispatch(ReportsOfSickness.Actions.Tabs.OPEN_DETAILS, {
      employee: employee,
      reportOfSickness: reportOfSickness
    });
  },

  [ReportsOfSicknessResource.Actions.Update.SUCCESS] ({ commit, getters }, data) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'EditReportOfSickness'));

    /* TO-DO: remove after removal of Tabs */
    commit('UPDATE_REPORT_OF_SICKNESS_DETAILS_TAB_AFTER_UPDATE_SUCCESS', data);
  },

  [ReportsOfSicknessResource.Actions.Delete.SUCCESS] ({ commit, getters }, reportOfSickness) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs
        .find(tab => tab.component === 'ReportOfSicknessDetails' &&
          tab.props._reportOfSickness.id === reportOfSickness.id));
  },

  [ReportsOfSicknessResource.Actions.UwvDecision.Create.SUCCESS] ({ commit, getters }) {
    commit(ReportsOfSickness.Mutations.Tabs.CLOSE,
      getters.reportsOfSicknessTabs.find(tab => tab.component === 'NewUwvDecision'));
  },

  [ReportsOfSickness.Actions.REFRESH] ({ commit, dispatch, rootGetters }, data) {
    const employee = rootGetters.employees.find(e => e.id === data.newReportOfSickness.employeeId);
    commit(ReportsOfSicknessResource.Mutations.ADD, data.newReportOfSickness);
    commit(ReportsOfSicknessResource.Mutations.REMOVE, data.oldReportOfSickness);

    dispatch(ReportsOfSickness.Actions.Tabs.CLOSE, rootGetters.reportsOfSicknessTabs.find(t => t.component === 'ReportOfSicknessDetails' && t.props._reportOfSickness.id === data.oldReportOfSickness.id))
      .then(dispatch(ReportsOfSickness.Actions.Tabs.OPEN_DETAILS, { reportOfSickness: data.newReportOfSickness, employee: employee }));
  }
};

const mutations = {
  [ReportsOfSickness.Mutations.CLEAR] (state) {
    state.reportsOfSicknessTabs = [
      new SubNavigationTab({
        component: 'ReportsOfSicknessIndex',
        text: 'Verzuim overzicht',
        props: null,
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: false,
        closeAction: null,
        isSingleTon: true,
        isActive: true
      })
    ];
  },

  [App.Mutations.CLEAR] (state) {
    state.reportsOfSicknessTabs = [
      new SubNavigationTab({
        component: 'ReportsOfSicknessIndex',
        text: 'Verzuim overzicht',
        props: null,
        navigateAction: ReportsOfSickness.Actions.Tabs.OPEN,
        isCloseable: false,
        closeAction: null,
        isSingleTon: true,
        isActive: true
      })
    ];
  },

  [ReportsOfSickness.Mutations.Tabs.ADD] (state, payload) {
    state.reportsOfSicknessTabs = TabHelper.addTab(payload, state.reportsOfSicknessTabs);
  },

  [ReportsOfSickness.Mutations.Tabs.CLOSE] (state, payload) {
    if (payload != null) {
      TabHelper.removeTab(payload, state.reportsOfSicknessTabs);
    }
  },

  [ReportsOfSickness.Mutations.Tabs.OPEN] (state, payload) {
    state.reportsOfSicknessTabs = TabHelper.activateTab(payload, state.reportsOfSicknessTabs);
  },

  'UPDATE_REPORT_OF_SICKNESS_DETAILS_TAB_AFTER_UPDATE_SUCCESS' (state, payload) {
    state.reportsOfSicknessTabs.forEach(r => {
      if (
        r.component === 'ReportOfSicknessDetails' &&
        r.props._reportOfSickness.id === payload.id
      ) {
        r.text = r.text.split('op')[0] + ' op ' + Helpers.Dates.formatDate(payload.firstSickDayIsoDate);
      }
    });
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
